/* istanbul ignore file */

const URL_TO_STAGE = {
  'localhost:3000': 'dev',
  'dlcce97v516qb.cloudfront.net': 'alpha',
  'dtjp19k85n8vx.cloudfront.net': 'beta',
  'd3dkpx48dsyibc.cloudfront.net': 'gamma',
  'd1cm1ee2dkvox6.cloudfront.net': 'prod',
  'd94i6jw2ho26m.cloudfront.net': 'secgov',
  'd1r1301rn47fwm.cloudfront.net': 'risk',
};

/* eslint-disable camelcase */
const AMPLIFY_CONFIG = {
  alpha: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:8a985eff-6799-4d97-ba9c-6f5531425892',
      userPoolId: 'us-east-1_BnU4bol2G',
      userPoolWebClientId: 'vj2tivlfcgck9d6mt276osfo9',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-alpha.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://alpha.policy.a2z.com',
      redirectSignOut: 'https://alpha.policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://vnyxrit2pvglffoezcmc5xmr4y.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  beta: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:0bf9c2ee-d8be-4aa0-93c6-685c3356699e',
      userPoolId: 'us-east-1_xW69bkDmz',
      userPoolWebClientId: '1ajfpqmn46e95213mogkdmucbf',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-beta.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://beta.policy.a2z.com',
      redirectSignOut: 'https://beta.policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://2sxqrd4dr5fv3fhglxof64n4oi.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  gamma: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:08fb3ffe-48d2-42b5-9357-a31582515da5',
      userPoolId: 'us-east-1_nXjQbgc66',
      userPoolWebClientId: '2ijp3t3ngpq866l9liohon1hli',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-gamma.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://gamma.policy.a2z.com',
      redirectSignOut: 'https://gamma.policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://2wb4a63tvjfzbnlo4dfig2wmum.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  prod: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:d24de118-53a4-4ae2-b14e-162bd86fdb6a',
      userPoolId: 'us-east-1_b2fnqR6Jz',
      userPoolWebClientId: '719db9mpbpmverr5veb998kbd8',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-prod.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://policy.a2z.com',
      redirectSignOut: 'https://policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://rknphatu5rb4vm4h5vmqwe4vba.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  dev: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:8a985eff-6799-4d97-ba9c-6f5531425892',
      userPoolId: 'us-east-1_BnU4bol2G',
      userPoolWebClientId: 'vj2tivlfcgck9d6mt276osfo9',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-alpha.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'http://localhost:3000',
      redirectSignOut: 'http://localhost:3000',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://vnyxrit2pvglffoezcmc5xmr4y.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  secgov: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:d24de118-53a4-4ae2-b14e-162bd86fdb6a',
      userPoolId: 'us-east-1_b2fnqR6Jz',
      userPoolWebClientId: '719db9mpbpmverr5veb998kbd8',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-prod.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://secgov.fintech.amazon.dev',
      redirectSignOut: 'https://secgov.fintech.amazon.dev',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://rknphatu5rb4vm4h5vmqwe4vba.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  risk: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:08fb3ffe-48d2-42b5-9357-a31582515da5',
      userPoolId: 'us-east-1_nXjQbgc66',
      userPoolWebClientId: '2ijp3t3ngpq866l9liohon1hli',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-gamma.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://risk.gamma.policy.a2z.com',
      redirectSignOut: 'https://risk.gamma.policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://2wb4a63tvjfzbnlo4dfig2wmum.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
  proda2z: {
    Auth: {
      region: 'us-east-1',
      identityPoolId: 'us-east-1:d24de118-53a4-4ae2-b14e-162bd86fdb6a',
      userPoolId: 'us-east-1_b2fnqR6Jz',
      userPoolWebClientId: '719db9mpbpmverr5veb998kbd8',
      mandatorySignIn: true,
    },
    oauth: {
      domain: 'policymanagement-prod.auth.us-east-1.amazoncognito.com',
      scope: ['openid'],
      redirectSignIn: 'https://policy.a2z.com',
      redirectSignOut: 'https://policy.a2z.com',
      responseType: 'code',
    },
    API: {
      aws_appsync_region: 'us-east-1',
      aws_appsync_graphqlEndpoint: 'https://rknphatu5rb4vm4h5vmqwe4vba.appsync-api.us-east-1.amazonaws.com/graphql',
    },
  },
};

let Stage;
const PATH = 'policy.a2z.com';
const SECGOVPATH = 'secgov.fintech.amazon.dev';
const A2ZPATH = 'policy.a2z.com';
const RISKPATH = 'risk.gamma.policy.a2z.com';

if (window.location.host in URL_TO_STAGE) {
  Stage = URL_TO_STAGE[window.location.host];
} else if (window.location.host === PATH) {
  Stage = 'prod';
} else if (window.location.host === SECGOVPATH) {
  Stage = 'secgov';
} else if (window.location.host === A2ZPATH) {
  Stage = 'proda2z';
} else if (window.location.host === RISKPATH) {
  Stage = 'risk';
} else if (window.location.host.endsWith(PATH)) {
  const { host } = window.location;
  [Stage] = host.split('.');
} else {
  Stage = 'dev';
}

const appConfig = {
  Stage,
  AmplifyConfig: AMPLIFY_CONFIG[Stage],
};

export default appConfig;

/**
 * WAF config — per-account integration URL + API key.
 * Each stage's AWS account needs its own key/URL created via:
 *   aws wafv2 create-api-key --scope REGIONAL --region us-east-1 --token-domains policy.a2z.com --profile policy-<stage>
 */
interface WafStageConfig {
  integrationUrl: string;
  apiKey: string;
}

// Alpha (948710311118). Dev (localhost) reuses Alpha's AppSync.
const WAF_ALPHA: WafStageConfig = {
  integrationUrl: 'https://a684215c9537.us-east-1.captcha-sdk.awswaf.com/a684215c9537',
  apiKey: 'eaQR6MmpB4bZTjvIe3EFBXhbZNaZUuQ6QKG2c11imvuF0UoEdiaBmt2Geo8tbYHwfummDfgyY44IEKLJ8d4+7WFQuTs+dCQ4eRGDEGx3iQ0pz3HAPJ9hqESPCHGpM6iKKIxLwcEqBurBabdg7Niu4dL0QhqCnGgyL/ePOQQKgdbjxvtR+9K5qeCdRI38ByUh3yVE1+UaEy19SK4Ytkohv79u5mERAw0WhDhVe17Nuqj1PWo3KUQj9IWHFGbmsKl+85ZNH5aZ6kd4TpE+e/4Fanthvc7O27G0XIL0mvUoggTNGZRcLo+53xFWy1o6KVisfWptJMgzseckDktci5k0RmhIC4+ZsmXf5DNpih1KH+OsaRry+3oli+wS1VBkg4ypa9oRnBcrL4UFhz8Aew6jDKWN6/WyQiHyIsFngKlILr3pwZhPB5Izyh+avZ7bA5KJBKvtElcDlWUVzQGoYvZMCmuLthdbvHTkppCoogI9F+k8buOjXRWWULtOzwCDbOXLw0gri3mOBX9SwJa7YNoW/pRftuQNRNFCqhcrQmOb+fVsiTew7X7HqLpWZCSqLHscGDr+wPQ4GliC3cB82ODdBB/aSLIEgPc4WZgGB63q9dD9griNww3Kj1nadXqoyPGyOS+uWpuJ0YYeqLH45oLcQiWL7mf4Hh/uDqgDxOyZapA=_0_1',
};

// Stages sharing an AWS account MUST reuse the same constant.
const WAF_BETA: WafStageConfig = {
  integrationUrl: 'https://866fbf089cf7.us-east-1.captcha-sdk.awswaf.com/866fbf089cf7',
  apiKey: 'ptGRlA5dyYtm3b9cdXtRYhw6BeE8QZ1mF168b14IioDfFIuPbxVQpQXZHk4p8Ora+2xdzNtYnkyUWkQHb2V1Dwj3VBaoQjTwqB5MKHPL6HHSHDyP6Zz5e8BmIAEvNGdR6lJIRtOBRb+JK+FIcmEuS1m/eVU2K2eju1rCfD0ZNSpnrS6Y+V0hZzg7slwxOjB4LichnG5LA7SA7Q0+xpzaNj8MdMekzeSSwW2BcjvIBCSJqZu4vvsa+XDyp56myC4g+hu3qqjfeDeP6FwMD5JrTdha8l1gPH8vH2/yedgmFjOEgDlN6gnm9KPS4z0e8l+gnulTI28Wa9NKEizX/T3+s18B9kkX0G7cLWaeUBVv03G1vwCCHe2CRCj4+/kik10bc5TsnS1tPt7zW6/im2/JEm5M/EEvFBt9GDIJoqy5YzaoUUxGN7zHPiSpt8965ouq+cUiXYv5XWKVHARzRZ2dHqyX09KxyNROegoGy2y/g/gt+ANYjFJJQ/cHcfoiJbY3vOfNf8BQecJVAqp+PJKFrm3psQCqi/DFVsfDnrW24PpQbenn/hy6bh4qWapADz0eNfixKI/gwOCiIampONL100oL5u6oNMmoImIFVqvtk0YbOOGQ9flLPb93g7MNqrA21emJ+oTM6aTVDq47wbkn6bljMkgPZlfRkK4G1kL2YY8=_0_1',
};
const WAF_GAMMA: WafStageConfig = {
  integrationUrl: 'https://0dc1cf5ccb46.us-east-1.captcha-sdk.awswaf.com/0dc1cf5ccb46',
  apiKey: 'iC2l8POMyFmszjHxMcoBEmmwtH9omQ6AG0VPuZZzrqz3vxPaxFjeVoGrKtrw5nQ3ppPzlYBRDAbsWRxzbNl0bFgd9JbYycEEnC8+AAYwYX72YoHtp7U95A7nlQjCvRaQWz8rYMVdHibV4zKOndVM2jwsPFai9G6o6/zkDaQ2crpkrYgFlTgleRL2MWtzXVYXulfDYqVy2knL5hHwJ4irzH4rgTY2nXzRQAO5Prmwx5CIiaKQ3me41eJDQbLmj6AFE7WGiZ2XyD2Qr+yIynFdUVyUixQtYpLvbdhd3J/ID0LbobLUehS9yvRvWevJuoz/fWGKeBoGtokJN9y3FuZGrSuRrer7RPXD2NBZIA2HhMY1wznjAESq2UN5Q2/q48l33evmIoGgNB3WwJcA4XK2Dz9Rs8AkEVnpyd7O1Oj92E+aKpoLMRlLp53in4LmI2j2nlR/8ZDy2phaoMLk5quiSf/i+G1udg25Zdr4AUy1T9/MgVLMCu/ed2cbQ6ap7nppVUUqb+fE6g6UWdiLp2bvoSWtN7yBerDbXz11Yi06owPH6pv5Eb1uZNvcFbjhWwx4+QoeAWy0ZlWCmyHM/+Mnrj8sA2I82ZOheu7qc1tauMCwWnfyCWd0h4I+vIyKIiTVeGQCVDbIj7CpkjEpeAZquNuBxccuTJgrMKUTTXP9tAI=_0_1',
};
const WAF_PROD: WafStageConfig = {
  integrationUrl: 'https://614e2b1540a8.us-east-1.captcha-sdk.awswaf.com/614e2b1540a8',
  apiKey: 'Qv0ThA3/gzPHobHu61Btv138wG6L9LB/O2oZH6EL2+Aiyji1uZjWZG696bvn8K88hrPIge4Up/cKaivqdbyuYoFub/9Z5OQ6JTRrqhtaQsrnoJJyRZ2zIip78MpkYnp0EGh3QZPMQ2VzcOjvmLuOKQmTjNrUtGaUqMa3T684so7T8/6fsdWTZUA8mqnZ7qI68Vg99tKwkZbMSX5iTqUrp8i57Ioedp1sJB08RRYoHBGerdJ2Fyi8YQxMdMh/gxpOmSRCynj3rJPp5i62Rfaw6BoBlW0CHbWCmkjVG5mp3TNQHxL10W4oRTC2FIyJOKfEdKhbiN0vhd4Kv2F/w+H22AJbk/aiG89lsjLOpLQetjlprYcUiqI7az5nNSjr3gU8Up4GoVRUEVzaHT1/nUnPvZ4K4T5PjJ8VqdvA9NhSuZdLmRJWp4M1ZuCQkIAHvR6OekgZmyqv8Pr/+5Bu1yYZ+s8v7ABWoCulo6jWV6AhWfcy5YhRN2PqdOw90cB1xd4JbH50zk3vAoCEgxuk0VzYcWNPgLlQi0mPkZR859gfFar3EmVaEuDUPFo/n+jrxJMujB0YBmeeGXVY+3QX6CKYTRQdv7mMVBuTWz2HV2oNaVDmAPFseF6iXobEm8u2uyXfncRFuJICvXh8J3Lc+HerpegY+ivhyr7IOwfaAei+6Aw=_0_1',
};

// Stage → config mapping. Missing key hits the warn fallback.
const WAF_STAGE_CONFIG: Partial<Record<string, WafStageConfig>> = {
  dev: WAF_ALPHA,     // localhost → Alpha AppSync
  alpha: WAF_ALPHA,
  beta: WAF_BETA,
  gamma: WAF_GAMMA,
  risk: WAF_GAMMA,    // risk shares Gamma's account
  prod: WAF_PROD,
  proda2z: WAF_PROD,  // shares Prod's account
  secgov: WAF_PROD,   // shares Prod's account
};

const wafStageConfig: WafStageConfig = WAF_STAGE_CONFIG[Stage] ?? (() => {
  // eslint-disable-next-line no-console
  console.warn(`[WAF] Unknown stage "${Stage}" — token attachment disabled. Add it to WAF_STAGE_CONFIG.`);
  return { integrationUrl: '', apiKey: '' };
})();

export const WAF_INTEGRATION_URL = wafStageConfig.integrationUrl;
export const WAF_API_KEY = wafStageConfig.apiKey;
export const WAF_TOKEN_DOMAIN = 'policy.a2z.com';
export const WAF_ENABLED = !!WAF_INTEGRATION_URL && !!WAF_API_KEY;
